export const axiosErrorHandler = error => {
  if (error.response) {
    if (error.response.status !== 401) {
      return Promise.reject({ ...error })
    }
  } else {
    return Promise.reject({ ...error })
  }

  //TODO: Agregar la url para refrescar el token antes de cerrar sesion

  //Removiendo las credenciales no validas y refrescando la url par obligar el cierre de sesion
  localStorage.removeItem('user')
  location.reload()
}

export const axiosSuccessHandler = response => {
  return response
}
